import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";

const partners = [
  { name: "DP World", logo: "assets/images/ScreenShot/addWarehousess.png" },
  { name: "Delhivery", logo: "assets/images/ScreenShot/dashboardss.png" },
  { name: "Ecom Express", logo: "assets/images/ScreenShot/forwordShipmentss.png" },
  { name: "Blue Dart", logo: "assets/images/ScreenShot/help.png" },
  { name: "Safexpress", logo: "assets/images/ScreenShot/kycPending.png" },
  { name: "Movein Logistics", logo: "assets/images/ScreenShot/Ndrss.png" },
  { name: "Amazon Shipping", logo: "assets/images/ScreenShot/profile.png" },
  { name: "Allcargo Logistics", logo: "assets/images/ScreenShot/rateCalculatorss.png" },
  { name: "Allcargo Logistics", logo: "assets/images/ScreenShot/rateCard.png" },
  { name: "Allcargo Logistics", logo: "assets/images/ScreenShot/reports.png" },
  { name: "Allcargo Logistics", logo: "assets/images/ScreenShot/trackss.png" },
  { name: "Allcargo Logistics", logo: "assets/images/ScreenShot/viewWarehousess.png" },
];

export default function RegisterPanelCarousel() {
  return (
    <section className="py-8 bg-white">

      <h2 className="text-center text-6xl font-bold bg-gradient-to-r from-blue-900 to-indigo-500 bg-clip-text text-transparent pb-4">
        Our Panels
      </h2>

      <div className="w-full">

        <Swiper
          modules={[Autoplay, EffectFade, Pagination, Navigation]}
          slidesPerView={1}
          loop={true}
          effect="fade"
          speed={800}
          style={{ width: "100%" }}

          autoplay={{
            delay: 1800,
            disableOnInteraction: false,
          }}

          pagination={{ clickable: true }}
          navigation={true}
        >
          {partners.map((partner, index) => (
            <SwiperSlide key={index}>
              <div className="flex items-center justify-center h-[400px] w-full">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-full w-[90%] object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
}